__turbopack_context__.v({
  "iconContainer": "Icon-module__qE_PtG__iconContainer",
});
